import { set_message } from './../actions/setMessage';
import { set_open_menu, toggle_open_menu } from './../actions/openMenu';
import {
    change_app_setting_content,
    change_app_setting_content_primary,
    change_app_setting_main_page,
    change_app_setting_point_modal,
    change_app_setting_right_modal,
    change_app_setting_sidebar,
    change_app_snapshot_main_page,
    discard_snapshot_settings,
} from '../modules/setting/actions/previewSideBar';
import { open_pick_point } from '../modules/points/actions/openPickPoint';

export const setting = window.lend_setting || {};

const initialState = {
    route: document.getElementById('_route').getAttribute('content'),
    setting: setting,
    snapshot: setting,
    message: {
        isOpen: false,
    },
    pickPointModal: {
        isOpen: true,
    },
    stateMenu: {
        isOpen: false,
    },
};

export const appReducer = function (state = initialState, action) {
    switch (action.type) {
        case open_pick_point: {
            return {
                ...state,
                pickPointModal: {
                    ...state.pickPointModal,
                    isOpen: action.data,
                },
            };
        }
        case change_app_setting_sidebar: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    sidebar: {
                        ...action.data,
                    },
                },
            };
        }
        case change_app_setting_content: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    content: {
                        ...action.data,
                    },
                },
            };
        }
        case change_app_setting_content_primary: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    content: {
                        ...state.setting.content,
                        primary: {
                            ...state.setting.content.primary,
                            ...action.data,
                        },
                    },
                },
            };
        }
        case change_app_snapshot_main_page: {
            return {
                ...state,
                snapshot: {
                    ...state.setting,
                    mainPage: action.data,
                },
            };
        }
        case discard_snapshot_settings: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    mainPage: [...state.snapshot.mainPage],
                },
            };
        }
        case change_app_setting_main_page: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    mainPage: action.data,
                },
            };
        }
        case change_app_setting_right_modal: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    rightModal: {
                        ...action.data,
                    },
                },
            };
        }
        case change_app_setting_point_modal: {
            return {
                ...state,
                setting: {
                    ...state.setting,
                    pointModal: {
                        ...action.data,
                    },
                },
            };
        }
        case set_message: {
            return {
                ...state,
                message: {
                    ...state.message,
                    isOpen: true,
                    type: action.message_type,
                    text: action.text,
                },
            };
        }
        case 'delMessage': {
            return {
                ...state,
                message: {
                    ...state.message,
                    isOpen: false,
                    type: action.message_type,
                    text: action.text,
                },
            };
        }
        case toggle_open_menu: {
            return {
                ...state,
                stateMenu: {
                    isOpen: !state.stateMenu.isOpen,
                },
            };
        }
        case set_open_menu: {
            return {
                ...state,
                stateMenu: {
                    isOpen: action.data,
                },
            };
        }
        default:
            return state;
    }
};
